import WithModal from "@components/HOC/withModals";
import MinerProfileFields2 from "@components/Pages/Managment/MinerPrifilesInfo/MinerProfileFields/MinerProfileFields2";
import Error from "@components/global/new/Error/Error";
import Title from "@components/global/new/Title/Title";
import { MODALS_ENUM } from "@constants/Modals";
import { createMinerProfileEditorStore } from "@mobx/store/minerProfiles/editor";
import { Button } from "antd";
import { observer } from "mobx-react-lite";
import { useEffect, useRef, useState } from "react";
import styles from "../CreateMinerProfile/CreateMinerProfile.module.scss";
import { ICreateMinerProfileMobxProps } from "./CreateMinerProfileMobx.props";
import { useCreateMinerProfileMobxControl } from "./useCreateMinerProfileMobxControl";

function CreateMinerProfileMobx(props: ICreateMinerProfileMobxProps) {
  const [editorStore] = useState(() => createMinerProfileEditorStore());
  const control = useCreateMinerProfileMobxControl(props, editorStore);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    editorStore.createEmpty();

    return () => editorStore.clear();
  }, [editorStore]);

  useEffect(() => {
    if (ref.current && ref.current.parentElement) {
      ref.current.parentElement.style.width = "fit-content";
    }
  }, [ref]);

  return (
    <div className={styles.wrapper} ref={ref}>
      <Title>{props.formatMessage({ id: "modal.create_profile.title" })}</Title>
      <form onSubmit={control.onSubmit} autoComplete="off">
        <MinerProfileFields2
          editorStore={editorStore}
          disabled={false}
          errors={control.errors}
        />
        {control.errors && <Error errors={{ fill: true }} />}
        <div className={styles.btns}>
          <Button onClick={props.handleClose}>
            {props.formatMessage({ id: "modal.change_pass.cancel" })}
          </Button>
          <Button
            htmlType="submit"
            type="primary"
            loading={control.loading}
            disabled={!editorStore.canSave}
          >
            {props.formatMessage({ id: "modal.create_plan.btn.create" })}
          </Button>
        </div>
      </form>
    </div>
  );
}

export default WithModal(
  MODALS_ENUM.MINERS_PROFILE_CREATE_MOBX_MODAL,
  observer(CreateMinerProfileMobx)
);
